class ResponseUserSettingsModel {
    constructor({
                    clearingNumber = '',
                    accountNumber = '',
                    warning = '',
                    consentId = '',
                    iban = '',
                    bank = '',
                } = {}) {
        this.clearingNumber = clearingNumber;
        this.accountNumber = accountNumber;
        this.warning = warning;
        this.consentId = consentId;
        this.iban = iban;
        this.bank = bank;
    }

    static getAttributes(filter = null, validationSchema = null, optionsData = null) {
        const attributes = {
            clearingNumber :{
                'label': 'Clearing Number',
                'sortable': true,
                'sortField': "clearingNumber",
                'value': (item) => item.clearingNumber || "",
            },
            accountNumber :{
                'label': 'Account Number',
                'sortable': true,
                'sortField': "accountNumber",
                'value': (item) => item.accountNumber || "",
            },
            bank :{
                'label': 'Bank',
                'sortable': true,
                'sortField': "bank",
                'value': (item) => item.bank || "",
            },
        }

        return attributes;
    }
}

export default ResponseUserSettingsModel;